import React from 'react'
import {Route, Switch} from 'react-router'
import {ROUTES} from '../App'
import Home from "../pages/home/home";
import NotFound from "../pages/notFound/notFound";

const ContentRouter = () => {
	return (
		<Switch>
			{ROUTES.map(route => {
				const {key, path, exact, component} = route;
				return (
					<Route
						key={key}
						path={path}
						exact={exact}
						component={component}
					/>
				)
			})}
			<Route path={'/myoauth2client/myUserInfo'}>
				<Home/>
			</Route>
			<Route path={'/'}>
				<NotFound/>
			</Route>
		</Switch>
	)
}

export default ContentRouter